import {axiosService} from "../axios.service";
import {urls} from "../../constants";


const semiFinishedService = {
    getAllSemiFinished: () => axiosService.get(urls.semiFinished.semiFinishedR).then(value => value.data),
    getSemiFinishById: (id) => axiosService.get(`${urls.semiFinished.semiFinishedR}/${id}`).then(value => value.data),
    createSemiFinish: (data) => axiosService.post(urls.semiFinished.semiFinishedR, data).then((value) => value.data),
    updateSemiFinishById: (id, data) => axiosService.patch(`${urls.semiFinished.semiFinishedR}/${id}`, data).then((value) => value.data),
    deleteSemiFinishById: (id) => axiosService.destroy(`${urls.semiFinished.semiFinishedR}/${id}`),
}

export {
    semiFinishedService
}